import { useMemo } from "react";

export function useUpdateOnChange<T>(obj: T, replacer?: (this: any, key: string, value: any) => any, reviver?: (this: any, key: string, value: any) => any): T {
    const serializedObj = JSON.stringify(obj, replacer);
    return useMemo<T>(() => JSON.parse(serializedObj, reviver), [serializedObj]);
}